import ExternalTerminalLinkIcon from "@material-ui/icons/Storage";

import { ExternalTerminalLinkList } from "./List/List";

export { ExternalTerminalLinkList };

export const externalTerminalLinkResource = {
	list: ExternalTerminalLinkList,
	icon: ExternalTerminalLinkIcon,
};
